import { render, staticRenderFns } from "./deliveryModeMapImport.vue?vue&type=template&id=33c31ca8"
import script from "./deliveryModeMapImport.vue?vue&type=script&lang=js"
export * from "./deliveryModeMapImport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports